'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactSlidedown = require('react-slidedown');

var _components = require('../../components');

var _Media = require('./Media.css');

var _Media2 = _interopRequireDefault(_Media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQ = (_dec = (0, _reactCssModules2.default)(_Media2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FAQ, _Component);

  function FAQ(props) {
    (0, _classCallCheck3.default)(this, FAQ);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FAQ.__proto__ || (0, _getPrototypeOf2.default)(FAQ)).call(this, props));

    _this.clickViewMoreReleaseDFA = function () {
      _this.setState({ viewMoreReleaseDFA: !_this.state.viewMoreReleaseDFA });
    };

    _this.clickViewMoreReleaseLaunch = function () {
      _this.setState({ viewMoreReleaseLaunch: !_this.state.viewMoreReleaseLaunch });
    };

    _this.renderReleaseDFAButton = function () {
      var label = !_this.state.viewMoreReleaseDFA ? 'View the full release' : 'View less';
      return _react2.default.createElement(
        'div',
        { styleName: 'company-table-wrapper' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'palm-oil-divestment-goes-mainstream' }),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-title' },
          'Palm Oil Divestment Goes Mainstream'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Dec. 22, 2016 \u2014 World\u2019s First Broadly-Diversified \u201CDeforestation Free\u201D Global Equity Portfolios Now Available to Everyday Investors'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-button', onClick: _this.clickViewMoreReleaseDFA },
          label,
          _react2.default.createElement(_components.LinkIcon, { faclass: _this.state.viewMoreReleaseDFA ? 'fa-angle-up' : 'fa-angle-down' })
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewMoreReleaseDFA ? _this.renderReleaseDFA() : null
        )
      );
    };

    _this.renderReleaseDFA = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'company-table' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'San Francisco \u2013'
          ),
          ' In response to the financial, social, and environmental risks of commodities that drive tropical deforestation and climate change, Dimensional Fund Advisors, a major US investment firm with $445 billion of assets under management, has divested two of its portfolios of all palm oil plantation companies, ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://bit.ly/sustfin1222' },
            'Bloomberg'
          ),
          ' reports today.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Palm oil production is the fastest growing cause of rainforest destruction and\xA0rainforest destruction is the second biggest driver of climate change\xA0after the burning of fossil fuels.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'A ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://webiva-downton.s3.amazonaws.com/877/72/7/8646/Invested_in_Exploitation.Digital.compressed.pdf' },
            'report'
          ),
          ' released by Friends of the Earth earlier this year examines the role of US investment firms in fueling tropical deforestation and land grabbing. That report, as well as data available through ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: '/' },
            'Deforestation Free Funds'
          ),
          ', a web portal hosted by Friends of the Earth and the shareholder advocacy organization As You Sow, show that Dimensional is among the top ten US financiers of the palm oil sector.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dimensional worked with ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://macroclimate.com/' },
            'Macroclimate'
          ),
          '\xAE \u2013 the world\u2019s first automated personal divestment platform \u2013\xA0along with other consultants and wealth managers not affiliated with Dimensional, to eliminate major climate stressors like palm oil producers',
          _react2.default.createElement(
            'sup',
            null,
            '1'
          ),
          ' from the firm\u2019s sustainability funds.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\xA0The move by Dimensional to remove all palm oil companies from two of its sustainability portfolios \u2013 US Sustainability Core 1 Portfolio (DFSIX) and International Sustainability Core 1 Portfolio (DFSPX) \u2013\xA0 makes these the first broadly diversified US and international funds from a top-ten U.S. fund manager to explicitly exclude palm oil. These funds are also divested from many of the largest owners of coal, oil and gas reserves as well as ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://macroclimate.com/coal' },
            'coal-fired power plants \u2013 the #1 climate problem, according to experts'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CDimensional is always looking for ways to improve the sustainability considerations for those two funds,\u201D Dimensional spokesman Alex Stockham told Bloomberg.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CWe are extremely pleased that Dimensional has taken this step towards deforestation free investing by ridding a few of its portfolios of problematic palm oil companies,\u201D said Jeff Conant, Senior International Forest Campaigner with Friends of the Earth-US. \u201CThere\u2019s a lot more to be done by Dimensional and every other US investment firm \u2013 but this signals an important first step in moving away from funding destructive palm oil practices.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The companies that had been in Dimensional\u2019s sustainability portfolios prior to this divestment move include ',
          _react2.default.createElement(
            'i',
            null,
            'Wilmar International'
          ),
          ' (WIL:SI), ',
          _react2.default.createElement(
            'i',
            null,
            'Olam International '
          ),
          '(OLAM:SI), ',
          _react2.default.createElement(
            'i',
            null,
            'Sipef SA'
          ),
          ' (SIP:BR), and ',
          _react2.default.createElement(
            'i',
            null,
            'Indofood Agri Resources LTD'
          ),
          ' (IFAR:SI). Three of the companies have been the focus of recent reports of serious environmental and social abuses: ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.amnesty.org/en/latest/news/2016/11/palm-oil-global-brands-profiting-from-child-and-forced-labour/' },
            'Wilmar'
          ),
          ' and ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://d3n8a8pro7vhmx.cloudfront.net/rainforestactionnetwork/pages/15889/attachments/original/1465330857/RAN_The_Human_Cost_of_Conflict_Palm_Oil.pdf?1465330857' },
            'Indofood'
          ),
          ' for child labor, forced labor, and other labor problems and Olam for massive ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.ft.com/content/bd2de89a-c01b-11e6-9bca-2b93a6856354' },
            'habitat destruction'
          ),
          ' in Gabon. It is unclear whether these reports bore a direct influence on Dimensional\u2019s divestment decision, however.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dimensional continues to hold shares in these and other companies involved in tropical deforestation through many other funds. According to data available on ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: '/' },
            'DeforestationFreeFunds.org'
          ),
          ', the firm still has 27 mutual funds with more than $700 million in assets invested across more than 44 palm oil plantation companies.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Dimensional\u2019s investment approach focuses on \u201Cdimensions\u201D (or \u201C',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://blog.macroclimate.com/about-factor-investing/' },
            'factors'
          ),
          '\u201D) with higher expected returns, while continuing to limit risk through diversification \u2013 and now ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://macroclimate.com/divestment' },
            'divestment'
          ),
          '.',
          _react2.default.createElement(
            'sup',
            null,
            '2'
          ),
          ' Today\u2019s Bloomberg article, ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://newsletters.briefs.bloomberg.com/document/9ez21n9mlwlzjvdta/investing' },
            '\u201CDimensional Dumps Palm Oil From Sustainable Funds,\u201D'
          ),
          ' includes a chart showing that the four palm oil producers that Dimensional has dropped have underperformed the MSCI World Index, which tracks global equity.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Macroclimate and Friends of the Earth will continue urging Dimensional to address its considerable holdings in forest-risk commodities and to expand sustainability criteria to other portfolios.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CIf investors on a global scale divert their capital from companies causing deforestation to those with more climate-resilient alternatives,\xA0the risks of abrupt and irreversible climate change will be materially reduced,\u201D says Mark R. Kriss, Managing Partner of Macroclimate\xAE. \u201CBy accelerating the divestment and deforestation-free investment movements, not only can we measurably improve climate outcomes, but we can also reduce risk and improve financial outcomes for everyday investors.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CIt\u2019s encouraging to see Dimensional responding to investors who want to keep their savings out of unsustainable palm oil production,\u201D said Andrew Montes, Director of Digital Strategies at As You Sow. \u201CAddressing the role our 401ks and other personal investments play in contributing to rainforest destruction is critical, and we hope to see other major asset managers taking similar steps.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'sup',
            null,
            '1'
          ),
          '\xA0Companies engaged in irresponsible and unethical deforestation practices\xA0per Friends of the Earth and other leading environmental NGOs with observers in the field.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'sup',
            null,
            '2'
          ),
          '\xA0For methodology details, see\xA0',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://macroclimate.wufoo.com/forms/pg2ujjq07nx816/' },
            _react2.default.createElement(
              'i',
              null,
              'The Evolution of Sustainability Investing'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'For more information contact:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Friends of the Earth U.S., Jeff Conant,'
          ),
          ' ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:jconant@foe.org' },
            'jconant@foe.org'
          ),
          ', ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'tel:575.770.2829' },
            '575 770 2829'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Macroclimate, Mark Kriss'
          ),
          ', ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:mkriss@macroclimate.com' },
            'mkriss@macroclimate.com'
          ),
          ', ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'tel:415.723.9695' },
            '415.723.9695'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'As You Sow, Andrew Montes,'
          ),
          ' ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:amontes@asyousow.org' },
            'amontes@asyousow.org'
          ),
          ', ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'tel:510.735.8144' },
            '510 735 8144'
          )
        )
      );
    };

    _this.renderReleaseLaunchButton = function () {
      var label = !_this.state.viewMoreReleaseLaunch ? 'View the full release' : 'View less';
      return _react2.default.createElement(
        'div',
        { styleName: 'company-table-wrapper' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'american-retirement-funds-are-destroying-rainforests' }),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-title' },
          'American retirement funds are destroying rainforests'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Jul. 26, 2016 \u2014 Innovative new web tool empowers citizen investor action on deforestation'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-button', onClick: _this.clickViewMoreReleaseLaunch },
          label,
          _react2.default.createElement(_components.LinkIcon, { faclass: _this.state.viewMoreReleaseLaunch ? 'fa-angle-up' : 'fa-angle-down' })
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewMoreReleaseLaunch ? _this.renderReleaseLaunch() : null
        )
      );
    };

    _this.renderReleaseLaunch = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'company-table' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'WASHINGTON, D.C. -\xA0'
          ),
          'A new transparency tool, ',
          _react2.default.createElement(
            'strong',
            null,
            '\u201CDeforestation Free Funds,\u201D'
          ),
          ' shows which global mutual funds contain palm-oil-related holdings, the fastest growing cause of rainforest destruction today. Friends of the Earth and As You Sow created this ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: '/' },
            'free online database'
          ),
          ' to allow individual investors, for the first time ever, to determine their links to tropical deforestation and land grabs. The tool then ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: '/faq#how-it-works' },
            'empowers investors'
          ),
          ' to demand deforestation-free investment options and responsible policies from workplace retirement plan managers and major fund families.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The search platform, which currently encompasses 6,500 global mutual funds, will be expanded in the future to include all market drivers of deforestation. Currently, some 10 percent of the global palm oil industry is financed by equity investors, including many mutual funds. As of June 2016, U.S. mutual funds had a net investment of more than $5 billion dollars in palm oil producers.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Andrew Behar, CEO of As You Sow'
          ),
          ', said, \u201CInvestments in palm oil are embedded in our pension funds, IRAs, and 401(k)s but most of us are not even aware of it. This web tool empowers investors to know exactly what they own so that they can pressure fund managers to implement sustainable investment policies and find investment options that support a forest-friendly future.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'A ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://www.foe.org/deforestation-free-action' },
            'new report'
          ),
          ' by Friends of the Earth, which accompanies the database, names the top 10 U.S. asset managers invested in palm oil production, including BlackRock, Vanguard, CalPERS, TIAA-CREF and Dimensional Fund Advisors. The report also shows that none of these firms have clear criteria for disclosing or avoiding risks related to deforestation and land rights. ',
          _react2.default.createElement(
            'strong',
            null,
            '\u201CAre You Invested in Exploitation?\u201D'
          ),
          ' outlines ways that these institutions can take greater responsibility for the social and environmental impacts of their investments.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Jeff Conant, senior international forests program manager at Friends of the Earth'
          ),
          ', said, \u201CWhen Americans put their hard-earned money in savings and retirement accounts, they believe they are preparing for a better future. But large asset managers undermine that very future, globally speaking, by putting this money into destructive agribusiness firms, \xA0generally through complex investment chains and failures in due diligence. Financial managers must stop investing in companies that grab land from subsistence farmers and Indigenous people in order to install massive plantations with dangerous, low-wage labor.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The rapid expansion of oil palm plantations across the tropics has caused ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://www.foe.org/projects/oceans-and-forests/forests' },
            'social conflict and human rights abuses'
          ),
          ' in countries like Indonesia, Liberia, Nigeria, Guatemala and Malaysia. Destruction of native rainforests is driving orangutans, Sumatran tigers and other endangered species to the edge of extinction. Processed palm oil is used ubiquitously in over half of the packaged consumer products on shelves today, including lotions, shampoo, toothpaste, cookies, breakfast bars, instant noodles and donuts. It can be very challenging for consumers to avoid palm oil; this joint effort focuses on ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://www.asyousow.org/about-us/theory-of-change/' },
            'shareholder advocacy'
          ),
          ' as an avenue to greater tropical forest protections.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'In the past few years, thanks to public pressure, dozens of consumer brands and palm oil traders have promised to stop burning and destroying forests, grabbing land, and abusing human rights. But ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'http://www.foe.org/projects/oceans-and-forests/forests/up-in-smoke' },
            'promises have been slow to materialize'
          ),
          ', and the finance industry has yet to address its role in driving destructive palm oil expansion. Furthermore, as \u201CAre You Invested in Exploitation?\u201D argues, the palm oil sector has concentrated tremendous wealth and power in countries with weak democracies and poor human rights records. These conditions enable corruption \u2014 something that investors should studiously avoid.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The tool highlights socially responsible funds that carefully consider issues like the environment and human rights. Some of these funds invest in companies specifically to gain a voice at the table, engage management and create real improvements in the company\u2019s behavior. If individuals look up their investments and aren\u2019t satisfied, Deforestation Free Funds can show them better-rated alternatives, and amplify their calls for reform. Future evolutions of the website will include information about all commodified sources of deforestation, including timber, paper, cattle, soy and sugar.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'For more information, visit ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: '/' },
            'DeforestationFreeFunds.org'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Expert contacts:',
            _react2.default.createElement('br', null)
          ),
          'Jeff Conant, Friends of the Earth, (510) 900-0016,\xA0',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:jconant@foe.org' },
            'jconant@foe.org'
          ),
          _react2.default.createElement('br', null),
          'Andrew Montes, As You Sow, (510) 735-8144,\xA0',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:amontes@asyousow.org' },
            'amontes@asyousow.org'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Communications contacts:'
          ),
          _react2.default.createElement('br', null),
          'Kate Colwell, (202) 222-0744,\xA0',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:kcolwell@foe.org' },
            'kcolwell@foe.org'
          ),
          _react2.default.createElement('br', null),
          'Taraneh Arhamsadr, As You Sow, (510) 735-8157,\xA0',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:tarhamsadr@asyousow.org' },
            'tarhamsadr@asyousow.org'
          )
        )
      );
    };

    _this.state = {
      viewMoreReleaseDFA: true,
      viewMoreReleaseLaunch: false
    };
    return _this;
  }

  (0, _createClass3.default)(FAQ, [{
    key: 'render',
    value: function render() {
      var mediaTitle = 'Media';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(mediaTitle)
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'faq' },
            _react2.default.createElement(
              'div',
              { styleName: 'faq-inner' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                mediaTitle
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answers' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Get in touch'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Media and General Inquiries'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Andrew Montes, Director of Digital Strategies, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        { xstrong: true, styleName: 'contact', to: _config2.default.links.contact },
                        'Contact',
                        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' }),
                        ' '
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Recent media releases'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.renderReleaseDFAButton(),
                    this.renderReleaseLaunchButton()
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FAQ;
}(_react.Component)) || _class);
exports.default = FAQ;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Media/Media.js
// module id = 1328
// module chunks = 0